import {
  ValidateIf,
  ValidateNested,
  IsString,
  IsNotEmpty,
  IsOptional,
  IsBoolean,
  IsArray,
  IsIn,
} from 'class-validator';
import { Type } from 'class-transformer';

import { WorkflowTransition } from '@app/gen/settings';

import { NodeActionAttributeDto } from './node-action-attribute.dto';

export class NodeActionDto {
  @IsIn(['accept', 'upload', 'sign', 'decline', 'return'])
  @IsNotEmpty({ message: 'Обязательное поле' })
  type?: WorkflowTransition['action_type'];

  @IsBoolean()
  @IsNotEmpty({ message: 'Обязательное поле' })
  isPrimary: boolean;

  @IsString()
  @IsOptional()
  name?: string;

  @ValidateIf((dto: NodeActionDto) => dto.type === 'sign')
  @IsIn(['pep', 'unep', 'ukep'])
  @IsNotEmpty()
  signType?: 'pep' | 'unep' | 'ukep';

  @ValidateIf(
    (dto: NodeActionDto) => dto.type === 'upload' || dto.type === 'sign',
  )
  @IsNotEmpty({ message: 'Обязательное поле' })
  documentName?: string;

  @IsArray()
  @IsOptional()
  roles?: string[];

  @IsArray()
  @IsOptional()
  @ValidateNested({ each: true })
  @Type(() => NodeActionAttributeDto)
  attributes?: NodeActionAttributeDto[];
}
